import React from "react";
import { numberWithCommas } from "common/helper";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import isItStandardViewver from "../../themesCommon/isItStandardViewer";
import { Icon, smSize } from "../../../../common/icon";
import ConfirmDeleteComponent from "../../../../common/components/confirmDelete/index";
import { useModelPopup } from "../../../../common/hooks";

import { ProjectState, UserInline, UserInlineTypes } from "../../../primitives";
import styles from "./styles.module.scss";

const ProjectRow = ({ project, projectName, isFord, selectedCouncilTag }) => {
  const history = useHistory();
  const popup = useModelPopup();
  const { enqueueSnackbar } = useSnackbar();
  const {
    councilReducer: { selectedCouncil },
    authReducer: { session },
    themesReducer: {
      themesMainReducer: { currentThemeData },
    },
  } = useSelector((state) => state);

  const handleDeleteProject = (themeId, id) => {
    popup.show({
      title: "Confirmation Delete",
      show: true,
      height: "300",
      width: "540",
      component: (
        <ConfirmDeleteComponent
          id={themeId}
          templateId={id}
          enqueueSnackbar={enqueueSnackbar}
          councilId={selectedCouncil?.id}
          actionType="deleteThemeProject"
        />
      ),
    });
  };
  // console.log("---------project,project", project);
  const handleProjectRedirect = (id) => {
    history.push(`/projects/${id}/overview`);
  };
  return (
    <div className={styles.gridRow}>
      <div
        className={styles.project}
        onClick={() => handleProjectRedirect(project.project_id)}
      >
        {projectName || "-"}
      </div>
      <div className={styles.owners}>
        {isFord ? (
          project.project_plant
        ) : (
          <>
            {project.project_owners?.map((o) => (
              <div className={styles.owner}>
                <UserInline
                  userId={o?.owner_id}
                  first={o?.owner_name}
                  last={""}
                  avatar={o?.owner_avatar}
                  local
                  type={UserInlineTypes.WITH_NAME}
                />
              </div>
            ))}
          </>
        )}
      </div>
      <div className={styles.access}>
        {isFord
          ? project?.project_rating
          : project?.project_access.charAt(0).toUpperCase() +
            project?.project_access.slice(1)}
      </div>{" "}
      {selectedCouncilTag !== "firmenich" ? (
        <div className={styles.task}>
          {isFord ? project?.project_replications : project?.project_stage}
        </div>
      ) : null}
      <div className={styles.task}>
        {isFord ? (
          <>$ {numberWithCommas(project?.project_savings) || "0"}</>
        ) : (
          <ProjectState
            key={project?.project_status}
            state={project?.project_status}
          />
        )}
      </div>{" "}
      {isFord ? (
        <div className={styles.task}>
          {" "}
          <>$ {numberWithCommas(project?.project_investment) || "0"}</>{" "}
        </div>
      ) : (
        ""
      )}
      {isFord ? (
        <div className={styles.task}> {project?.project_tarr} %</div>
      ) : (
        ""
      )}
      {/* <div className={styles.shortCol}>
        {isItStandardViewver(session, currentThemeData) && (
          <Icon
            {...smSize}
            icon="icn-button-delete"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              return handleDeleteProject(
                currentThemeData.id,
                project.project_id
              );
            }}
          />
        )}
      </div> */}
    </div>
  );
};
export default ProjectRow;
